const secondary = {
    social_bind_with: 'Máš už účet? Přihlas se a propoj ho se svým {{methods, list(type: disjunction;)}} sociálním účtem.',
};
export default Object.freeze(secondary);
